export class AntibioticsReq {

    fromDate?:Date;
    toDate?:Date;
    indentNumber?: number;
    page?:number;
    pageSize?:number

    constructor(
        fromDate?:Date,
        toDate?:Date,
        indentNumber?: number,
        page?:number,
        pageSize?:number
    ){
        this.fromDate= fromDate
        this.toDate = toDate
        this.indentNumber = indentNumber
        this.page = page
        this.pageSize = pageSize
       
        
    }
}
